import React from 'react';
import {
    ETitleColor,
    ETitleBackground,
    ETitlePosition,
    ESubTitlePosition,
    ETextSize,
    ETextWeight,
    EWrapperType, ETopMargin
} from "../styles";

const MenuItem = ({
                      titleText,
                      subTitleText,
                      price,
                      titleColor,
                      titlePosition,
                      titleBackgroundColor,
                      subTitlePosition,
                      titleSize,
                      topMargin
                  }) => {

    return (
        titleText === '' ?
        <></>
        :
        <div className={`${ETitleBackground[titleBackgroundColor] || ''} ${EWrapperType[titlePosition] || ''} ${ETopMargin[topMargin] || ''}`}>
            <h1 className={`${ETitleColor[titleColor] || ''} ${ETextSize[titleSize] || ''} ${ESubTitlePosition[subTitlePosition] || ''} ${ETitlePosition[titlePosition] || ''} ${ETextWeight.BOLD} w-full`}>
                {titleText.replaceAll('"""', '"')}
                {subTitleText.split(';').length !== 0 && subTitleText.split(';').map((line, index) => {
                    return <span key={index} className={`ml-2 ${ETextWeight.LIGHTBOLD} ${ETextSize.SMALL}`}>{line.replaceAll('"""', '"')}</span> })}
            </h1>
            {price !== '' && <h3 className={`${ETextSize.SMALL} ${ETextWeight.BOLD}  shrink-0  ml-2`}>{price}</h3>}
        </div>
    );
};

export default MenuItem;